import { EventEmitter } from '@angular/core';
var NgInitDirective = /** @class */ (function () {
    function NgInitDirective() {
        this.initEvent = new EventEmitter();
    }
    NgInitDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.isLast) {
            setTimeout(function () { return _this.initEvent.emit(); }, 10);
        }
    };
    return NgInitDirective;
}());
export { NgInitDirective };
